import { ShoppingCartIcon, Trash2Icon } from 'lucide-react';
import React from 'react'
import { Badge, Card, Col, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const DrugCard = ({ drug, addToCart, updateQuantity, carted, quantity }) => {
    const handleCartClick = () => {
        addToCart(drug, carted);
    };

    const handleIncrease = () => {
        updateQuantity(drug.id, quantity + 1);
    };

    const handleDecrease = () => {
        if (quantity > 1) {
            updateQuantity(drug.id, quantity - 1);
        }
    };

    const drugQty = drug?.batches?.reduce((sum, item) => sum + Math.abs(Number(item.quantity)), 0 )
    console.log(drugQty)

    return (
        <Col onClick={handleCartClick} sm="4" md='3' className='mb-2'>
            <Card  className="card-event">
                <Card.Body className='d-flex align-items-center gap-2 p-2'>
                    <div className="avatar">
                        <span className={"avatar-initial fs-sm bg-primary"}>
                            <i className="ri-shopping-cart-line"></i>
                        </span>
                    </div>
                    <div className='d-flex flex-column align-items-start w-100'>
                        <h6><Link to="" className='fs-sm'>{drug?.name}</Link></h6>
                        <p className="text-secondary fs-sm m-0">Stock: {drugQty}</p>
                    </div>
                </Card.Body>
                <div className="divider divider-start fw-medium m-0"></div>
                <Card.Footer onClick={(e)=>e.stopPropagation()} className='d-flex justify-content-between p-2'>
                    <span className='fs-sm'>&#8358;{drug?.batches[0]?.costPrice.toLocaleString()}</span>

                    <div className='d-flex gap-2 align-items-center'>
                        {carted ? (
                            <>
                                <Button size="sm" variant="outline-secondary" onClick={handleDecrease}>-</Button>
                                <span>{quantity}</span>
                                <Button size="sm" variant="outline-secondary" onClick={handleIncrease}>+</Button>
                                <Badge style={{ cursor: "pointer" }} bg="" className=' text-danger' onClick={handleCartClick}><Trash2Icon/></Badge>
                            </>
                        ) : (
                            <Button 
                                aria-disabled={!drugQty}
                                style={{ 
                                    background: "none", 
                                    border: "none", 
                                    padding: 0,
                                    cursor: drugQty === 0 ? 'not-allowed' : 'pointer'
                                }}  
                                className={`text-success border-0 ${!drugQty? 'cursor-not-allowed' : "cursor-pointer"}`} 
                                onClick={handleCartClick}
                                >
                                    <ShoppingCartIcon className='text-success'/>
                            </Button>
                        )}
                    </div>
                </Card.Footer>
            </Card>
        </Col>
    );
};

export default DrugCard;
